import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authGoogleSession } from '../api/client';
import { useStore } from '../context/StoreContext';

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { refreshUser } = useStore();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    (async () => {
      const hash = location.hash || '';
      const m = hash.match(/session_id=([^&]+)/);
      const sessionId = m ? decodeURIComponent(m[1]) : null;
      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }
      try {
        await authGoogleSession(sessionId);
        await refreshUser();
      } catch (err) {
        console.error('[AuthCallback] google session exchange failed:', err);
      } finally {
        // Clean the hash then redirect home
        window.history.replaceState(null, '', '/');
        navigate('/', { replace: true });
      }
    })();
  }, [location.hash, navigate, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-[#39ff14]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto rounded-full border-2 border-[#39ff14] border-t-transparent animate-spin" />
        <p className="mt-3 text-xs tracking-widest font-bold">SIGNING YOU IN…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
